"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CriterionRow_1 = __importDefault(require("@Components/Search/SearchWithCriteria/CriterionRow"));
const CriteriaRows = ({ searchCriteriaStore, disableAutoComplete, fields }) => (react_1.default.createElement(react_1.default.Fragment, null, fields.map((field, index) => (react_1.default.createElement(CriterionRow_1.default, { criterion: field, searchCriteriaStore: searchCriteriaStore, key: field.id, index: index, disableAutoComplete: disableAutoComplete })))));
exports.default = CriteriaRows;
